import React from "react";
import { Box, Button } from "@mui/material";
import { useModal } from "../../../contexts/modal/hooks";

export const ChooseActionButtons = ({
  onDiscard,
  onTriggerRun,
}: {
  onDiscard: () => void;
  onTriggerRun?: (runName: string) => void;
}) => {
  const { goToNextStep, closeModal } = useModal();

  return (
    <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
      <Button
        variant="outlined"
        color="error"
        onClick={() => {
          onDiscard();
          closeModal();
        }}
      >
        Discard Changes
      </Button>
      {onTriggerRun && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            goToNextStep();
          }}
        >
          Save & Trigger New Run
        </Button>
      )}
    </Box>
  );
};
